<template>
  <!-- 弹层仅客户端挂载，避免旧内核 Teleport SSR hydration mismatch -->
  <ClientOnly>
    <Teleport to="body">
      <Transition name="ws" :duration="280">
        <div v-if="modelValue" class="wd-sheet" :class="{ elevated }">
          <div class="ws-mask" @click="close" />
          <div class="ws-body">
            <div v-if="grip" class="ws-grip" />

            <div v-if="plainHeader" class="ws-title">
              {{ title }}
              <button type="button" class="ws-x" :aria-label="t('common.close')" @click="close">
                ✕
              </button>
            </div>
            <div v-else class="ws-h">
              <b>{{ title }}</b>
              <button type="button" class="dw-x" :aria-label="t('common.close')" @click="close">
                ✕
              </button>
            </div>

            <slot />
          </div>
        </div>
      </Transition>
    </Teleport>
  </ClientOnly>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue: boolean
    title: string
    grip?: boolean
    plainHeader?: boolean
    /** 叠在已有 BottomSheet 之上 */
    elevated?: boolean
  }>(),
  { grip: false, plainHeader: false, elevated: false },
)

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const { t } = useI18n()
const close = () => emit('update:modelValue', false)
</script>

<style scoped lang="scss">
.wd-sheet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 90;

  &.elevated {
    z-index: 110;
  }
}

.ws-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(5, 5, 12, 0.6);
}

.ws-body {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 480px;
  margin: 0 auto;
  background: var(--surface);
  border-radius: 18px 18px 0 0;
  padding: 14px 14px calc(24px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid var(--hairline);
  max-height: 78vh;
  overflow: auto;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.3);
}

.ws-enter-active .ws-mask,
.ws-leave-active .ws-mask {
  transition: opacity 0.2s;
}

.ws-enter-from .ws-mask,
.ws-leave-to .ws-mask {
  opacity: 0;
}

.ws-enter-active .ws-body,
.ws-leave-active .ws-body {
  transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.ws-enter-from .ws-body,
.ws-leave-to .ws-body {
  transform: translateY(110%);
}

.ws-grip {
  width: 36px;
  height: 4px;
  border-radius: 3px;
  background: var(--hairline);
  margin: 2px auto 8px;
}

.ws-h {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 900;
  margin-bottom: 10px;
}

.dw-x {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--surface2);
  color: var(--muted);
  font-size: 14px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
}

.ws-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 900;
  color: var(--text);
  line-height: 1.2;
}

.ws-x {
  margin-left: auto;
  background: none;
  border: 0;
  color: var(--text);
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  padding: 2px 0 2px 10px;
  opacity: 0.9;

  &:active {
    opacity: 0.65;
  }
}
</style>
